import { PageProvider } from './PageProvider';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { UcThemeProvider } from './UcThemeProvider';

// Wrap any providers here so the main app.js looks cleaner
export const AppProvider = ({ children }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <UcThemeProvider>
                <CssBaseline enableColorScheme />
                <PageProvider>
                    {children}
                </PageProvider>
            </UcThemeProvider>
        </LocalizationProvider>
    );
};